export const PV_PORTAL_ASSESSMENT_VALUES = {
    'GENERAL 12': [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    'DC3.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    'DC3.2': [
        'compliant',
        'not_applicable',
        'not_cited',
        'non_regulatory',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    'GENERAL 14': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'GENERAL 8': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'GENERAL 9': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    INSTALL5: ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    INSTALL7: ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    INSTALL6: ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'GENERAL 10': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'GENERAL 11': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    WIRING20: ['compliant', 'not_applicable', 'not_cited', 'non_regulatory', 'minor_non_compliance'],
    'COMPONENTS1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'COMPONENTS2.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    CER1: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    CER2: ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    CER3: ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    CER4: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    CER5: ['not_applicable', 'non_regulatory'],
    'INSTALL 8': ['compliant', 'not_applicable', 'medium_non_compliance'],
    'INSTALL 9': [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    'GENERAL 4.2.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'rectification_work',
    ],
    'DC1.1.1.1.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC1.1.2.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work', 'unsafe'],
    'DC1.2.1.1.1.1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    'DC1.3.1.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'DC1.4.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'DC1.5.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'DC1.6.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'DC1.7': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC1.8.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC1.9.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC2.1.1.1.1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
        'unsafe',
    ],
    'DC2.2.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'DC2.3.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'DC2.4.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC2.5.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DC2.7': ['compliant', 'not_applicable', 'medium_non_compliance', 'rectification_work'],
    'DC2.8': [
        'compliant',
        'not_applicable',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    'DC2.9': [
        'compliant',
        'not_applicable',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    'DOC1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC10.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'DOC11.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'DOC12.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'DOC13.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC14.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'DOC2.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC3.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC7.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC8.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'DOC9.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'PROTECTION5.2': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'PROTECTION5.3': ['compliant', 'not_applicable', 'not_cited', 'unsafe'],
    'GENERAL 1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'GENERAL 2.2': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'GENERAL 2.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'GENERAL 3': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'GENERAL5.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'GENERAL 6.1': ['compliant', 'not_viewed', 'inverter_settings'],
    'GENERAL 6.2': ['compliant', 'not_viewed', 'inverter_settings'],
    'GENERAL 6.3': ['compliant', 'not_viewed', 'inverter_settings'],
    GENERAL7: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    'INSTALL1.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'INSTALL2.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'INSTALL3.1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    'INSTALL4.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'MECH1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'non_regulatory',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
        'unsafe',
    ],
    'MECH2.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    MECH3: ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'PROTECTION1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'PROTECTION2.1.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'PROTECTION4.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    PROTECTION5: [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    'PROTECTION5.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    PROTECTION6: ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'PROTECTION7.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    PROTECTION8: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    'SIGN1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    SIGN10: ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    SIGN11: ['compliant', 'not_applicable', 'not_cited', 'non_regulatory', 'minor_non_compliance'],
    SIGN12: ['compliant', 'not_applicable', 'not_cited', 'non_regulatory', 'minor_non_compliance'],
    'SIGN2.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    SIGN13: ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'SIGN3.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    SIGN14: ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'SIGN4.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'SIGN5.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    SIGN15: ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'SIGN7.2.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'SIGN8.1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'SIGN9.1.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'PROTECTION3.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    WIRING23: [
        'compliant',
        'not_applicable',
        'not_cited',
        'non_regulatory',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    WIRING24: [
        'compliant',
        'not_applicable',
        'not_cited',
        'non_regulatory',
        'minor_non_compliance',
        'medium_non_compliance',
    ],
    'WIRING10.2': ['compliant', 'not_applicable', 'not_cited', 'rectification_work', 'unsafe'],
    'WIRING10.1.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'WIRING11.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'WIRING12.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'WIRING13.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'WIRING16.1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    'WIRING16.2.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    WIRING17: ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    WIRING18: [
        'compliant',
        'not_applicable',
        'not_cited',
        'medium_non_compliance',
        'rectification_work',
    ],
    WIRING19: ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    WIRING21: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    WIRING22: [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'medium_non_compliance',
        'rectification_work',
    ],
    'WIRING2.1.1': [
        'compliant',
        'not_applicable',
        'not_cited',
        'minor_non_compliance',
        'rectification_work',
    ],
    'WIRING4.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'WIRING5.1.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'WIRING6.2': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
    'WIRING7.1': ['compliant', 'not_applicable', 'not_cited', 'rectification_work'],
    'WIRING8.1': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'WIRING8.2': ['compliant', 'not_applicable', 'not_cited', 'non_regulatory'],
    'WIRING9.1': ['compliant', 'not_applicable', 'not_cited', 'minor_non_compliance'],
    'WIRING1.1': ['compliant', 'not_applicable', 'not_cited', 'unsafe'],
    'WIRING15.1': ['compliant', 'not_applicable', 'not_cited', 'medium_non_compliance'],
};
//# sourceMappingURL=pv-portal-options.js.map